// styles.js
import { StyleSheet } from '@react-pdf/renderer';
import * as colors from '../../config/colors';

const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: '#000',
    borderStyle: 'solid',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    borderBottomStyle: 'solid',
  },
  tableCell: {
    fontSize: 6, // Fonte reduzida para melhor ajuste
    textAlign: 'right',
    padding: 5,
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#000',
    borderRightStyle: 'solid',
  },
  tableCellWide: {
    fontSize: 6, // Fonte menor para tipo de despesa e detalhe
    textAlign: 'right',
    padding: 5,
    flex: 2,
    borderRightWidth: 1,
    borderRightColor: '#000',
    borderRightStyle: 'solid',
  },
  tableHeader: {
    fontWeight: 'bold',
    backgroundColor: colors.primaryColor, // Fundo azul para cabeçalho
    color: '#fff', // Texto branco
    textTransform: 'uppercase', // Caixa alta
    textAlign: 'center',
  },
  totalRow: {
    fontWeight: 'bold',
    backgroundColor: colors.TotalColor, // Fundo amarelo para Total Geral e coluna Total
    color: '#000',
    textTransform: 'uppercase', // Caixa alta para Total Geral
  },
  subtotalRow: {
    fontWeight: 'bold',
    backgroundColor: colors.SubTotalColor, // Fundo verde claro para subtotais
    color: '#000',
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    paddingBottom: 10,
  },
  logo: {
    width: 90,
    height: 50,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    flex: 1,
  },
  date: {
    fontSize: 12,
    textAlign: 'right',
  },
});

export default styles;
